import { useEffect, useState } from "react";
import { facturxFetch } from "../../api/client";

export type BackupIncrStatus = {
  running: boolean;
  status: string;
  date: string;
  age_sec: number | null;
  live_files: number | null;
  dest_files: number | null;
};

export function useBackupIncr(open = true): BackupIncrStatus | null {
  const [state, setState] = useState<BackupIncrStatus | null>(null);

  useEffect(() => {
    if (!open) return;
    let stop = false;
    const load = () => {
      void facturxFetch<BackupIncrStatus>("backup-incr-status.php")
        .then((data) => {
          if (!stop) setState(data);
        })
        .catch(() => {
          if (!stop) {
            setState({
              running: false,
              status: "INJOIGNABLE",
              date: "",
              age_sec: null,
              live_files: null,
              dest_files: null,
            });
          }
        });
    };
    load();
    const t = window.setInterval(load, 60_000);
    return () => {
      stop = true;
      window.clearInterval(t);
    };
  }, [open]);

  return state;
}
